document.addEventListener('change',function(event){
  if(!event.target.matches('[data-variant-select]')) return;
  var option=event.target.options[event.target.selectedIndex];
  var price=option.getAttribute('data-price');
  var compare=option.getAttribute('data-compare');
  var root=event.target.closest('[data-product-root]');
  if(root&&price) root.querySelector('[data-product-price]').textContent=price;
  var compareNode=root&&root.querySelector('[data-compare-price]');
  if(compareNode) compareNode.textContent=compare||'';
});

document.addEventListener('DOMContentLoaded',function(){
  var cta=document.querySelector('[data-sticky-cta]');var target=document.getElementById('produit');
  if(!cta||!target||!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(entries){cta.classList.toggle('is-hidden',entries[0].isIntersecting);},{threshold:0.15}).observe(target);
});
